import { render, staticRenderFns } from "./CadastroCuidadoPrograma.vue?vue&type=template&id=5e6b5af1&scoped=true&"
import script from "./CadastroCuidadoPrograma.vue?vue&type=script&lang=js&"
export * from "./CadastroCuidadoPrograma.vue?vue&type=script&lang=js&"
import style0 from "./CadastroCuidadoPrograma.vue?vue&type=style&index=0&id=5e6b5af1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6b5af1",
  null
  
)

export default component.exports